import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import Config from "@/config";
import VueAxios from 'vue-axios'
import onResize from './iframe-height-update';
import VTooltip from 'v-tooltip'
import '@/assets/style.css'

axios.defaults.headers.post[ 'Content-Type' ] = 'multipart/form-data'
axios.defaults.headers.common[ 'x-api-key' ] = Config.api_key;

window.addEventListener( 'load', () => {
    onResize();
    window.addEventListener( 'resize', onResize );
} );


Vue.use( VTooltip)
Vue.use( VueAxios, axios )
Vue.config.productionTip = false

new Vue( {
    vuetify,
    render : function( h ) {
        return h( 'div', { class : 'cli-app-wrapper' }, [h( App )] )
    }
} ).$mount( '#app' )